import { answersBySurveyIdOptions } from "@pulse/api/queryApi";
import type { Question } from "@pulse/api/surveyApi";
import { shuffleArray } from "@pulse/utils/utils";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { QuestionContext } from "./QuestionContext";
import ResponseVariations from "./ResponseVariations";

export default function ResponseProvider({
    question,
    questionIndex,
}: {
    question: Question;
    questionIndex: number;
}) {
    const { data: allAnswers } = useQuery(
        answersBySurveyIdOptions({ surveyId: question.surveyId }),
    );

    const answers = useMemo(
        () => allAnswers?.filter((a) => a.surveyQuestionId === question.id) || [],
        [allAnswers, question.id],
    );

    const answersWithComments = useMemo(
        () =>
            shuffleArray(answers.filter((a) => a.comment && a.comment.answerComment.trim() !== "")),
        [answers],
    );

    return (
        <QuestionContext.Provider value={{ question, answers, answersWithComments, questionIndex }}>
            <div className="w-full">
                <ResponseVariations />
            </div>
        </QuestionContext.Provider>
    );
}
